import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CustomApiParameters } from 'src/app/common/helpers/custom-api-parameters';
import { ApiBaseService } from 'src/app/services/api-base.service';
import { NestedPopupService } from 'src/app/services/UI/nested-popup.service';
import { ParentCommunicatorService } from 'src/app/services/parent-communicator.service';
import { RootMember } from 'src/app/common/models/RootMember';
import { ParentMessageType } from 'src/app/common/models/ParentMessage';

@Injectable({
  providedIn: 'root'
})
export class MembershipUpgradePopupService extends NestedPopupService {

  constructor(private apiBaseService: ApiBaseService, private parentCommunicatorService: ParentCommunicatorService,
    private customApiParameters: CustomApiParameters) {
    super()
  }

  /**
  * get feature accessibility via apibase service
  */
  getFeatureAccess(generations): Observable<any> {
    console.log("membership access")
    console.log(generations)
    this.customApiParameters.clearAllParams();
    let customParaList = this.customApiParameters.
      addCustomParameter("FeatureId", generations).
      getCustomParaList();

    return this.apiBaseService.get("/api/membership/memberaccess", customParaList, null);

  }

  /**
  * redirect to dashbord
  */
  goToHomePage(rootMember: RootMember) {
    this.parentCommunicatorService.send(ParentMessageType.RootMemberChanged, rootMember);
  }
}
